import { Highlight } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { generatePath } from "react-router";
import { ROUTES } from "../../../../../routes";
import { AnchorLink } from "../../../../AnchorLink/AnchorLink";
import type { FlatLocationOverviewData } from "../../LocationOverview.types";

function getSiteColumn(
  globalFilter = ""
): MRT_ColumnDef<FlatLocationOverviewData> {
  return {
    accessorKey: "site",
    header: "Liegenschaften",
    size: 220,
    enableGrouping: false,
    Cell: ({ row }) => {
      const { location } = row.original;
      return (
        <Site
          filter={globalFilter}
          id={location.site.id}
          name={location.site.name}
          projectId={location.project}
        />
      );
    }
  };
}

interface SiteProps {
  projectId: string;
  id: number;
  name: string;
  filter?: string;
}

function Site({ projectId, id, name, filter = "" }: SiteProps) {
  const path = generatePath(ROUTES.site.entry, {
    projectId,
    siteId: id.toString()
  });

  return (
    <AnchorLink href={path} target="_self">
      {filter ? <Highlight highlight={filter}>{name}</Highlight> : name}
    </AnchorLink>
  );
}

export { getSiteColumn };
